import { createSlice } from '@reduxjs/toolkit';
import moment from "moment";
import { RootState } from "../../store.ts";
import { GroupListItem} from "../groups/groupsService.ts";

interface FiltersState {
    phoneNumbersFilter: any;
    contactsFilter: any[];
    usersFilter: any[];
    callTypesFilter: string[];
    groupsFilter: GroupListItem | null;
    selectedDates: {
        from: string;
        to: string;
    };
    limit: number;
}

export const initialState: FiltersState = {
    phoneNumbersFilter: null,
    contactsFilter: [],
    usersFilter: [],
    callTypesFilter: [],
    groupsFilter: null,
    selectedDates: {
        from: moment().clone().subtract(100, 'years').startOf('day').toISOString(),
        to: moment().clone().add(100, 'years').endOf('day').toISOString()
    },
    limit: 20,
};

const filtersSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setPhoneNumbersFilter: (state, action) => {
            state.phoneNumbersFilter = action.payload;
        },
        setContactsFilter: (state, action) => {
            state.contactsFilter = action.payload;
        },
        setUsersFilter: (state, action) => {
            state.usersFilter = action.payload;
        },
        setCallTypesFilter: (state, action) => {
            state.callTypesFilter = action.payload;
        },
        setGroupsFilter: (state, action) => {
            state.groupsFilter = action.payload;
        },
        setSelectedDates: (state, action) => {
            state.selectedDates = action.payload;
        },
        setLimit: (state, action) => {
            state.limit = action.payload;
        },
    },
});

export const {
    setPhoneNumbersFilter,
    setContactsFilter,
    setUsersFilter,
    setCallTypesFilter,
    setSelectedDates,
    setLimit,
    setGroupsFilter
} = filtersSlice.actions;

export const getSelectedNumber = (state: RootState) =>
    state.filters.phoneNumbersFilter;
export const getSelectedUsers = (state: RootState) =>
    state.filters.usersFilter;
export const getSelectedGroups = (state: RootState) =>
    state.filters.groupsFilter;

export default filtersSlice.reducer;